<dx-popup
    [(visible)]="visible"
    [showTitle]="true"
    [title]="'สินค้า ' + sku"
    [dragEnabled]="true"
    [hideOnOutsideClick]="true"
    [showCloseButton]="true"
    [width]="560"
    height="auto"
>
    <div class="product-card">
        @if (loading) {
            <div class="muted">กำลังค้นหาสินค้าในคลัง lnwshop…</div>
        } @else if (error) {
            <div class="warn">ค้นหาสินค้าไม่ได้: {{ error }}</div>
        } @else if (product; as p) {
            <div class="product-body">
                @if (p.thumbnail) {
                    <a [href]="p.url || p.adminUrl" target="_blank">
                        <img
                            class="product-thumb"
                            [src]="p.thumbnail"
                            [alt]="p.title"
                        />
                    </a>
                }
                <div class="product-info">
                    <div class="product-title">{{ p.title }}</div>
                    <div class="product-meta">
                        <span><b>SKU</b> {{ p.sku }}</span>
                        <span><b>PID</b> {{ p.pid }}</span>
                        @if (p.price !== null) {
                            <span
                                ><b>ราคา</b> ฿{{
                                    p.price | formatNumber: 2
                                }}</span
                            >
                        }
                        @if (p.productType) {
                            <span><b>ประเภท</b> {{ p.productType }}</span>
                        }
                    </div>
                    <div class="product-meta">
                        <span
                            ><b>คงเหลือ</b>
                            <span class="stock">{{
                                p.remain ?? "–"
                            }}</span></span
                        >
                        <span><b>จองแล้ว</b> {{ p.reserve ?? "–" }}</span>
                        <span><b>ขายแล้ว</b> {{ p.sold ?? "–" }}</span>
                        @if (p.stockStatus) {
                            <span><b>สถานะ</b> {{ p.stockStatus }}</span>
                        }
                    </div>
                    <div class="product-links">
                        @if (p.url) {
                            <a [href]="p.url" target="_blank">หน้าร้าน</a>
                        }
                        @if (p.adminUrl) {
                            <a [href]="p.adminUrl" target="_blank"
                                >หลังร้าน lnwstore</a
                            >
                        }
                        @for (link of p.marketplaceUrls; track link.url) {
                            <a [href]="link.url" target="_blank">{{
                                link.label
                            }}</a>
                        }
                    </div>
                    @if (p.crawlerLastUpdated) {
                        <div class="muted">
                            ข้อมูลคลังอัปเดต
                            {{
                                p.crawlerLastUpdated
                                    | formatRelativeDatetime: "th"
                            }}
                        </div>
                    }
                </div>
            </div>
        } @else {
            <div class="muted">
                ไม่พบ SKU "{{ sku }}" ในคลังสินค้า lnwshop — อาจเป็น SKU
                เฉพาะบนแพลตฟอร์ม หรือถูกเปลี่ยนชื่อแล้ว
            </div>
        }
    </div>
</dx-popup>
